import { Component, OnInit, Input, SimpleChanges, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-primitive-column',
    templateUrl: './primitive-column.component.html',
    styleUrls: ['./primitive-column.component.css'],
})
export class PrimitiveColumnComponent implements OnInit, OnDestroy {
    // ✅ Implements OnDestroy

    @Input() config: any;

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            this.config = changes['config'].currentValue;
        }
    }

    ngOnDestroy(): void {
        // ✅ Correct placement
        //console.log('Component destroyed');
    }
}
